import { useEffect } from "react";
import { Input, Form, Select, Radio, Checkbox, Divider } from "antd";
import BraftEditor from "braft-editor";
import { getOptionArray, selectFilterOption, getDataArray } from "@/lib/antdElementFunction";
import { getLangList } from '@/lib/i18n';
import { ReRangePicker, ReButton } from "@/components/refineElement";
import { getMoment, dateTimeFormat4 } from "@/lib/dateTime";
import { hasPermission } from "@/lib/permissionUtil";

const layout = {
  labelCol: { lg: { span: 4 }, xs: { span: 24 }, sm: { span: 4 } },
  wrapperCol: { lg: { span: 18 }, xs: { span: 24 }, sm: { span: 18 } }
};

interface Props {
  form?: any;
  dataItemInfo: any;
  handleType: string;
  selectedDate: any;
  clickDelete: any;
  filterDepartmentArray: any;
  roleId: number
}

function ModalInfo(props: Props) {
  const { form, dataItemInfo, handleType, selectedDate, clickDelete, filterDepartmentArray, roleId } = props;
  const selectedDepartmentId = +dataItemInfo.departmentId;
  const hasDeletePermission = hasPermission(
    filterDepartmentArray?.find((item: any) => item.id === selectedDepartmentId)?.permissionIds?.[3] ?? 0
  );
  const isStudent = roleId === 2;
  const scheduleT: any = getLangList("schedule");
  const buttonT: any = getLangList("button");

  const options1 = [
    { label: scheduleT.YES, value: 1 },
    { label: scheduleT.NO, value: 0 },
  ];

  const options2 = [
    { label: scheduleT.TEACHER, value: 2 },
    { label: scheduleT.STUDENT, value: 1 },
  ];

  const inputProps = () => {
    return isStudent ? { disabled: true, bordered: false } : {};
  }

  useEffect(() => {
    const { title, isFocus, personType, departmentId, content, startTime, endTime } = dataItemInfo ?? {};

    if (handleType === 'update') {
      form.setFieldsValue({
        title,
        isFocus,
        personType: personType === 0 ? [1, 2] : [personType],
        departmentId: +departmentId,
        content,
        date: [getMoment(startTime), getMoment(endTime)],
      });
    } else if (handleType === 'create') {
      form.setFieldsValue({
        date: [
          getMoment(getMoment(selectedDate).startOf('day').format(dateTimeFormat4)),
          getMoment(getMoment(selectedDate).endOf('day').format(dateTimeFormat4)),
        ],
      });
    }
  }, [form, dataItemInfo, handleType, selectedDate]);

  return (
    <Form
      className="admin-form schedule-modal"
      {...layout}
      form={form}
      initialValues={{ isFocus: 1 }}
      disabled={isStudent}
    >
      <Form.Item label={scheduleT.IMPORTANT_ANNOUNCEMENT} name="isFocus">
        <Radio.Group options={options1} {...inputProps()} />
      </Form.Item>

      <Form.Item label={scheduleT.TIME} name="date">
        <ReRangePicker format='dateTimeFormat4' {...inputProps()} />
      </Form.Item>

      <Form.Item
        label={scheduleT.ANNOUNCEMENT_PLACE}
        name="departmentId"
        rules={[{ required: true }]}
      >
        <Select
          showSearch
          filterOption={(input: any, option: any) => selectFilterOption(input, option)}
          {...inputProps()}
        >
          {getOptionArray(getDataArray(filterDepartmentArray, 'id', 'departmentName'))}
        </Select>
      </Form.Item>

      <Form.Item
        label={scheduleT.ANNOUNCEMENT_TARGET}
        name="personType"
        rules={[{ required: true }]}
      >
        <Checkbox.Group options={options2} {...inputProps()} />
      </Form.Item>

      <Form.Item label={scheduleT.TITLE} name="title" rules={[{ required: true }]}>
        <Input {...inputProps()} />
      </Form.Item>

      <Form.Item
        label={scheduleT.CONTENT}
        name="content"
        rules={[{ required: true }]}
      >
        <BraftEditor
          readOnly={isStudent}
          {...{ controlBarStyle: isStudent ? { display: 'none' } : {} }}
          defaultValue={BraftEditor.createEditorState(dataItemInfo.content)}
          language="zh-hant"
        />
      </Form.Item>

      {handleType === 'update' && hasDeletePermission && !isStudent &&
        <>
          <Divider dashed />
          <Form.Item label={buttonT.DELETE}>
            <ReButton onClick={clickDelete} attributeObject={{ type: "danger" }} iconName='delete' />
          </Form.Item>
        </>
      }
    </Form>
  );
}

export default ModalInfo;